import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { OrgSettings } from '../models/meter-settings.model';

@Injectable()
export class MeterSettingsService {
    private baseUrl = `${environment.API_GATEWAY_URL}/iot/admin/settings`;

    constructor(private http: HttpClient) {}

    getSettings(): Observable<OrgSettings> {
        return this.http.get<OrgSettings>(this.baseUrl);
    }

    saveSettings(settings: OrgSettings): Observable<OrgSettings> {
        return this.http.put<OrgSettings>(this.baseUrl, settings);
    }
}
